import { EPAGE, IBaseProps } from './types';
import Index from './pages/Index/Index';
import Error from './pages/Error/Error';
import Page404 from './pages/404/Page404';
import Page50x from './pages/50x/Page50x';

import './App.scss';

const App: React.FC<IBaseProps> = ({ page }) => {
    return (
        <div className="App">
            {page === EPAGE.INDEX && <Index />}
            {page === EPAGE.ERROR && <Error />}
            {page === EPAGE.PAGE_404 && <Page404 />}
            {page === EPAGE.PAGE_50X && <Page50x />}
        </div>
    );
}

export default App;
